import $script from 'scriptjs';

let googleAnalytics = ($window, configService) => {
  let googleAnalyticsContainer = { functions: {} };
  googleAnalyticsContainer.trackers = [];
  googleAnalyticsContainer.instance = undefined;
  googleAnalyticsContainer.load = configService.get('analytics.loadAnalytics') || false;

  googleAnalyticsContainer.loadScript = () => {
    return new Promise((resolve) => {
      googleAnalyticsContainer.callExternalScript('https://www.google-analytics.com/analytics.js', () => {
        if ($window.ga) {
          googleAnalyticsContainer.collectAutoloaded();
          resolve();
        }
        resolve();
      });
    });
  };

  googleAnalyticsContainer.create = (tracker) => {
    if (!googleAnalyticsContainer.load || !$window.ga) {
      return false;
    }

    $window.ga('create', tracker.id, 'auto', tracker.name);
    $window.ga(tracker.name + '.require', 'ecommerce');
    googleAnalyticsContainer.trackers.push(tracker);
  };

  googleAnalyticsContainer.sendData = (data = 'pageview') => {
    for (let tracker of googleAnalyticsContainer.trackers) {
      $window.ga(tracker.name + '.send', data);
    }
  };

  googleAnalyticsContainer.sendEcommerce = () => {
    for (let tracker of googleAnalyticsContainer.trackers) {
      $window.ga(tracker.name + '.set', 'page', 'review');
      $window.ga(tracker.name + '.ecommerce:send');
    }
  };

  googleAnalyticsContainer.setData = (actionKey, actionValue) => {
    for (let tracker of googleAnalyticsContainer.trackers) {
      $window.ga(tracker.name + '.set', actionKey, actionValue);
    }
  };

  googleAnalyticsContainer.setEcommerce = (ecommerceType, ecommerceData) => {
    for (let tracker of googleAnalyticsContainer.trackers) {
      $window.ga(tracker.name + '.ecommerce:' + ecommerceType, ecommerceData);
    }
  };

  googleAnalyticsContainer.collectAutoloaded = () => {
    if ($window.ga && $window.ga.getAll) {
      let currentTrackers = $window.ga.getAll();
      let trackers = [];
      if (currentTrackers.length) {
        for (let i = 0; i < currentTrackers.length; i++) {
          let gtmTrackerName = currentTrackers[i].get('name');
          if (!gtmTrackerName) {
            gtmTrackerName = `gtm${i + 1}`;
            $window.ga('set', 'name', gtmTrackerName);
          }

          $window.ga(gtmTrackerName + '.require', 'ecommerce');
          googleAnalyticsContainer.trackers.push({ name: gtmTrackerName });
        }
      }

      return trackers;
    }
  };

  googleAnalyticsContainer.callExternalScript = (url, callback) => $script(url, callback);

  return googleAnalyticsContainer;
};

googleAnalytics.$inject = [ '$window', 'configService' ];

export default googleAnalytics;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/services/services/google.analytics.service.js